import styled from 'styled-components';

export const FormMultiSettingsAudienceWrapper = styled.div`
    padding: 0 2px 0 0px;
    line-height: 1.25;

    .inputWrapperBasicInput .MuiChip-root {
        max-width: 200px;
    }
`;

export const CreateListButtonWrapper = styled.div`
    padding: 16px 0;
`;

export const MailingPreferencesWrapper = styled.div`
    padding: 16px 2px 24px 8px;
`;

export const ToggleWrapper = styled.div`
    .MuiFormControlLabel-root {
        align-items: start;
        vartical-align: start;
    }
`;

export const ToggleLabelWrapper = styled.span`
    margin-left: 32px;
    text-wrap: wrap;
    display: block;
`;

export const LabelInputWrapper = styled.div`
    padding-bottom: 24px;
`;
